<template>
  <div class="contents users" v-loading="loading">
    <div class="title flexB">
      <h2>피드백 관리</h2>
    </div>
    <div class="filterWrap flex">
      <el-select v-model="inputMode">
        <el-option label="이메일" value="email"> </el-option>
        <el-option label="닉네임" value="nickname"> </el-option>
        <el-option label="피드백 내용" value="contents"> </el-option>
      </el-select>

      <input type="text" v-model="searchWord" @keyup.enter="search" />
      <button class="basic" @click="search">검색</button>
    </div>

    <div class="box one">
      <table>
        <colgroup>
          <col style="width: 8%" />
          <col style="width: 10%" />
          <col style="width: 26%" />
          <col style="width: 22%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 18%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>카테고리</th>
          <th>피드백 내용</th>
          <th>이메일</th>
          <th>닉네임</th>
          <th>구독여부</th>
          <th>작성일</th>
        </tr>
        <tr v-for="(data, i) in feedbackList" :key="i">
          <td>
            {{ total - ((currentPage - 1) * 10 + i) }}
          </td>
          <td>
            {{ getCategoryLabel(data.category) }}
          </td>
          <td>
            <router-link to @click.native="handleDetail(data._id)">
              {{ data.contents }}
            </router-link>
          </td>
          <td>
            <router-link
              to
              @click.native="handleUserDetail(data._id)"
              class="noPrimary"
            >
              {{ data.dropedAt != null ? "탈퇴회원" : data.email }}
            </router-link>
          </td>
          <td>{{ data.nickname }}</td>
          <td :class="{ primary: data.isMember == true }">
            {{ data.isMember ? "구독중" : "미구독" }}
          </td>

          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="feedbackList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { fetchFeedbackList } from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
export default {
  mixins: [format],
  components: { NoData },
  name: "feedbackManage",
  data() {
    return {
      moment: moment,
      inputMode: "",
      searchWord: "",
      feedbackList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      loading: false,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "7");
  },
  mounted() {
    // this.loading = true;
    this.getFeedbackList();
  },
  methods: {
    getCategoryLabel(category) {
      const categoryMap = {
        feature: "기능 제안",
        bug: "오류 신고",
        contents: "콘텐츠",
        learning: "학습 경험",
        other: "기타",
      };
      return categoryMap[category] || category || "-";
    },
    handleUserDetail(id) {
      this.$router.push({ name: "userDetail", query: { id: id } });
    },
    handleDetail(id) {
      this.$router.push({ name: "feedbackDetail", query: { id: id } });
    },

    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.feedbackList = [];
      this.total = 0;
      this.currentPage = 1;
      this.getFeedbackList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        return alert("검색 조건을 선택해 주세요.");
      }
      this.getFeedbackList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$router.push({ name: "users", query: { page: val } });
      this.getFeedbackList();
    },
    getFeedbackList() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        inputMode: this.inputMode,
        searchWord: this.searchWord,
      };
      fetchFeedbackList(params).then((res) => {
        console.log("fetchFeedbackList >>>>>", res);
        if (res.data.status == 200) {
          this.feedbackList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.currentPage = res.data.page;
          this.loading = false;
        } else if (res.data.status == 409) {
          this.$router.push("/");
          return alert(res.data.message);
        } else {
          alert(res.data.message);
        }
      });
    },
  },
};
</script>
